import { FadeInUp } from '../animations';

const whyTaiga = [
  { title: 'One Point of Contact', description: 'A single sourcing partner for all your India requirements.' },
  { title: 'Flexible Sourcing', description: 'Adaptable to different product types, volumes and timelines.' },
  { title: 'Multi-Category Access', description: 'Source across apparel, tiles, bathware, home decor and more.' },
  { title: 'Buyer-Focused Approach', description: 'Your product requirements drive every sourcing decision.' },
  { title: 'Production Follow-Up', description: 'Regular updates and coordination throughout production.' },
  { title: 'Quality Coordination', description: 'Inspection and quality follow-up at key production stages.' },
];

const WhyTaigaSection = () => (
  <section className="py-24 lg:py-32 bg-white" data-testid="why-taiga-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <FadeInUp className="text-center mb-16">
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#0B2A57] mb-4" style={{ fontFamily: 'Cabinet Grotesk' }}>
          WHY WORK WITH TAIGA?
        </h2>
      </FadeInUp>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {whyTaiga.map((item, i) => (
          <FadeInUp key={item.title} delay={i * 0.08}>
            <div className="p-6 border border-[#E5E0D8]/60 hover:shadow-sm transition-all">
              <h3 className="text-sm font-semibold tracking-wider uppercase text-[#0B2A57] mb-2">{item.title}</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">{item.description}</p>
            </div>
          </FadeInUp>
        ))}
      </div>
    </div>
  </section>
);

export default WhyTaigaSection;
